var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListUnordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.3C2.4 19.3.3 21.4.3 24s2.1 4.7 4.7 4.7 4.8-2.1 4.8-4.7-2.1-4.7-4.8-4.7zM5 .4C2.4.4.3 2.5.3 5.1S2.4 9.7 5 9.7s4.8-2 4.8-4.7S7.7.4 5 .4zm0 37.9C2.4 38.3.3 40.4.3 43s2.1 4.7 4.7 4.7 4.8-2.1 4.8-4.7-2.1-4.7-4.8-4.7zm9 7.7h33.7v-6H14v6zm0-19h33.7v-6H14v6zm0-25v6h33.7V2H14z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNNSwxOS4zYy0yLjYsMC00LjcsMi4xLTQuNyw0LjdzMi4xLDQuNyw0LjcsNC43czQuOC0yLjEsNC44LTQuN1M3LjcsMTkuMyw1LDE5LjN6IE01LDAuNAljLTIuNiwwLTQuNywyLjEtNC43LDQuN1MyLjQsOS43LDUsOS43czQuOC0yLDQuOC00LjdTNy43LDAuNCw1LDAuNHogTTUsMzguM2MtMi42LDAtNC43LDIuMS00LjcsNC43czIuMSw0LjcsNC43LDQuNwlzNC44LTIuMSw0LjgtNC43UzcuNywzOC4zLDUsMzguM3ogTTE0LDQ2aDMzLjd2LTZIMTRWNDZ6IE0xNCwyN2gzMy43di02SDE0VjI3eiBNMTQsMnY2aDMzLjdWMkgxNHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgListUnordered as ReactComponent };